module.exports = __webpack_public_path__ + "img/ico-cadastro.28c1f938.svg";